import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions, ITdDataTableColumn, TdDataTableSortingOrder, IPageChangeEvent, ITdDataTableSortChangeEvent, TdDataTableService, TdDialogService, TdLoadingService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Po } from '../po';
import { Branch } from '../../../accounting/branch';
import { PoService } from '../po.service';
import { Location } from '@angular/common';
import { PoOrder } from '../po-orders';
import { NullAstVisitor } from '@angular/compiler';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { ReceivingService } from '../../../receiving/receiving.service';
import { Supplier } from '../../suppliers/supplier';
import { PoSupplier } from '../poSupplier';
import { BranchService } from '../../../accounting/branches/branch.service';
import { ReportService } from '../../../../shared/services/report.service';
import { SupplierService } from '../../suppliers/supplier.service';
import { CollectionService } from '../../../../shared/services/collection.service';
import { CurrencyService } from '../../../../shared/services/currency.service';
import { SettingsService } from '../../../../shared/services/settings.service';

@Component({
  selector: 'app-po-new',
  templateUrl: './po-new.component.html',
  styleUrls: ['./po-new.component.scss'],
  providers: [ReportService, CollectionService, CurrencyService]
})
export class PoNewComponent implements OnInit {
  translatePipe: TranslatePipe = new TranslatePipe();
  currentPo: PoSupplier = new PoSupplier();

  originalPo: PoSupplier = new PoSupplier();

  // Select Boxes
  allStatuses: string[];

  allDesignColors$: Observable<any[]>;
  allCollections$: Observable<any[]>;
  allTransportWays$: Observable<string[]>;
  allSupplierPrefixes$: Observable<Supplier[]>;
  allBranches$: Observable<Branch[]>;

  title: string;
  isEditMode: boolean;
  
  _currencies: any[];

  _this_PO_currency: string = 'USD';

  // List
  collection: string;
  unit_type: string;
  design: string;
  length: number;
  unitPrice: number;

  saving: boolean = false;

  // By default we have the receivings order
  recv_pending: boolean = false;

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: this.translatePipe.transform('supplier_collection', this._authService.getLanguage())},
    { name: 'designColor', label: this.translatePipe.transform('supplier_design', this._authService.getLanguage()) 
      + '/' + this.translatePipe.transform('color', this._authService.getLanguage()) },
    { name: 'mysticCollection', label: this.translatePipe.transform('collection', this._authService.getLanguage())},
    { name: 'mysticDesignColor', label: this.translatePipe.transform('design', this._authService.getLanguage()) + '/' 
      + this.translatePipe.transform('color', this._authService.getLanguage()) },
    { name: 'quantity', label: this.translatePipe.transform('qty', this._authService.getLanguage())},
    { name: 'unit_price', label: this.translatePipe.transform('unit_price', this._authService.getLanguage()) }
  ];

  items: PoOrder[] = [];
  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 5;
  sortBy: string = 'collection';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  constructor(private _poService: PoService,
    private _dialogService: TdDialogService,
    private _viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
    private _loadingService: TdLoadingService,
    private _receivingService: ReceivingService,
    private _branchService: BranchService,
    private _collectionService: CollectionService,
    private _settingsService: SettingsService,
    private _supplierService: SupplierService,
    private router: Router,
    private _currencyService: CurrencyService,
    private location: Location,
    private _reportService: ReportService,
    private _dataTableService: TdDataTableService,
    public _authService: AuthenticationService) { }


  ngOnInit(): void {
    this._loadingService.register('loading');

    //this.allPos$ = this._poService.getAllPos();
    // My branches only
    //this.allBranches$ = this._poService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());

    //this.allSupplierPrefixes$ = this._poService.getSupplierPrefixes();
    this.allTransportWays$ = this._poService.getTransportWays();

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEdit(params.get('id'))
        : this.processNew())
      .subscribe((currentPo: PoSupplier) => {
        this.currentPo = currentPo;
        // If it was an existing PO retrieve items
        if (this.currentPo.po_id != null) {
          this._poService.getPoItems(currentPo.po_id + '').subscribe(
            response => {
              // For existing POs we want to display the supplier names as names
              response.forEach(
                (i) => {

                  let updatedItem: PoOrder = new PoOrder();

                  //console.log('mystic design name: ' + i['design_name']);

                  updatedItem.color_name = i['supplier_color_name'];
                  updatedItem.design_name = i['supplier_design_name'];
                  updatedItem.collection_name = i['supplier_collection_name'];
                  updatedItem.mystic_design_name = i['design_name'];
                  updatedItem.mystic_color_name = i['color_name'];
                  updatedItem.mystic_collection_name = i['collection_name'];
                  updatedItem.collection_id = i.collection_id;
                  updatedItem.color_id = i.color_id;
                  updatedItem.quantity = i.quantity;
                  updatedItem.unit_price = i.unit_price;
                  updatedItem.unit_type = i.unit_type;

                  //console.log('mystic design name: ' + updatedItem.mystic_design_name);
                  console.log(updatedItem);

                  this.items.push(updatedItem);
                }

              );
              //console.log(this.items);
              this.filter();
            }
          );

          // Set the currency
          this.filterCurrencies(this.currentPo.currency || '');
          this.setCurrency();

          if (this.currentPo.status == 'DRAFT') {
            // If this was stored as a DRAAFT, we are pending the RECEIVING ORDER
            this.recv_pending = true;
          }

          this.allStatuses = this.getValidStatuses(false);

          // Also set the supplier_ref_no to the PO number if it was empty
          if (this.currentPo.supplier_order_ref == null || this.currentPo.supplier_order_ref == '') {
            this.currentPo.supplier_order_ref = this.currentPo.po_number;
          }
        } else {
          this.allBranches$.subscribe(
            response => {
              if (response.length > 0) {
                this.currentPo.requesting_branch_id = response[0].id;
                this.branchChanged(this.currentPo.requesting_branch_id);
              }
            }
          );

          this.allStatuses = this.getValidStatuses(true);
        }

        // If it was an existing PO with a defined branch load its suppliers
        if (this.currentPo.requesting_branch_id != null && this.currentPo.requesting_branch_id > 0) {
          this.loadSuppliers(this.currentPo.requesting_branch_id);
        }

        // If it was an existing PO with a defined supplier load its collections
        if (this.currentPo.supplier_id != null && this.currentPo.supplier_id > 0) {
          this.loadCollections(this.currentPo.supplier_id);
          this.loadSupplierColors(this.currentPo.supplier_id);
        }

        this.originalPo = Object.assign({}, this.currentPo);

        this._loadingService.resolve('loading');
      });

    // second variant getting data prom service

    // let subscription = Observable.forkJoin(
    //   this._poService.getDesignColors(),
    //   this._poService.getCollections(),
    //   this._poService.getTransportWays(),
    //   this._poService.getStatuses(),
    //   this._poService.getSupplierPrefixes(),
    //   this._poService.getBranches(),
    //   this._poService.getPos()
    // ).subscribe((
    //   [
    //     designColors,
    //     collections,
    //     transportWay,
    //     statuses,
    //     supPrefixes,
    //     branches,
    //     pos
    //   ]: string[][]) => {
    //     this.allDesignColors = designColors;
    // });
  }

  getUnit(type: String) {
    if (type == 'LENGTH') {
      return 'Meters';
    } else if (type == 'AREA') {
      return 'Square Meters';
    } else {
      return 'Pieces';
    }
  }

  getUnitSymbol(type: String) {
    if (type == 'LENGTH') {
      return 'm';
    } else if (type == 'AREA') {
      return 'm²';
    } else {
      return '';
    }
  }

  branchChanged($event) {
    console.log($event)
    this._branchService.getBranch($event).subscribe(
      response => {
        this.currentPo.ship_to = response.address;
      }
    );
  }

  setCurrency() {
    console.log(this.currentPo.currency)
    if (this._currencies.some(c=>{return c.code == this.currentPo.currency})) {
      this._this_PO_currency=this.currentPo.currency;
    }
  }

  filterCurrencies($event) {
    this._currencies = this._currencyService.getAllCurrencies().filter(
      c => {
        return (c.code.toLowerCase().indexOf($event.toLowerCase()) >= 0 || c.description.toLowerCase().indexOf($event.toLowerCase()) >= 0);
      }
    )
  }

  addItemToList() {
    let message: string[] = [];

    if (this.collection == null) {
      message.push('Please select a Collection in order to add items to the list.')
    }

    if (this.design == null) {
      message.push('Please select a Color/Design in order to add items to the list.')
    }

    if (this.length == null) {
      message.push('Please enter the quantity in order to add items to the list.')
    }

    if (this.unitPrice == null) {
      message.push('Please enter the unit price in order to add items to the list.')
    }

    if (message.length > 0) {
      this._dialogService.openAlert({
        title: 'Missing information',
        message: message.join('\n')
      })
      return;
    }

    // If the product is already in the list, prevent it from going in again
    if (this.items.some((p) => { return p.color_id == this.design['id'] })) {
      this._dialogService.openAlert({
        title: 'Duplicated Product',
        message: 'The selected product already exists in the product list'
      })
      return;
    }

    this.items.push({
      collection_id: this.collection['id'],
      //collection_name: this.collection['name'],
      collection_name: this.collection,
      color_id: this.design['id'],
      color_name: this.design['color_name'],
      design_name: this.design['design_name'],
      mystic_color_name: '',
      mystic_design_name: '',
      quantity: this.length,
      unit_price: this.unitPrice
    })

    this.filter();
  }

  changed(): boolean {
    for (let prop in this.currentPo) {
      if (this.currentPo[prop] != this.originalPo[prop]) {
        return true;
      }
    }

    return false;
  }

  changedSupplier($event) {
    console.log($event);
    this.allSupplierPrefixes$.subscribe(s => { this.currentPo.supplier_code = s.find((c) => { return c.id == $event }).code });
    this.loadCollections($event);
    this.loadSupplierColors($event);
  }

  getValidStatuses(is_new: boolean): string[] {
    if (is_new) {
      return ['DRAFT', 'ORDERED'];
    } else {
      switch (this.currentPo.status) {
        case 'DRAFT':
          return ['DRAFT', 'ORDERED', 'CANCELLED'];
        case 'ORDERED':
          return ['ORDERED', 'CANCELLED'];
        default:
          return [this.currentPo.status];
      }
    }
  }

  getTotalMeters(): number {
    let t: number = 0;
    this.items.forEach(
      function (item) {
        t += item.quantity * 1; //The * 1 is to turn the string to number
      }
    );
    return t;
  }

  getTotalValue(): number {
    let t: number = 0;
    this.items.forEach(
      function (item) {
        t += item.quantity * item.unit_price;
      }
    );
    return t;
  }

  enterNewValueDialog(row: PoOrder, attr: string) {
    if (this.currentPo.status != 'DRAFT' && this.currentPo.status != 'ORDERED') {
      return;
    }

    this._dialogService.openPrompt({
      message: 'Enter new value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: row[attr],
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        row[attr] = newValue;
      } else {
        console.log('cancelled');
      }
    });
  }

  loadSuppliers($event) {
    this.allSupplierPrefixes$ = this._supplierService.getSupplierPrefixes($event);
  }

  loadCollections($event) {
    this.allCollections$ = this._collectionService.getCollections($event);
    this.allDesignColors$ = Observable.of([]);
  }

  loadColors($event) {
    this.allDesignColors$ = this._poService.getDesignColors($event['id']);
  }

  loadSupplierColors($event) {
    this.allDesignColors$ = this._poService.getSupplierColors($event);
  }

  createPo() {
    // Avoid double-click issues
    if (this.saving) return;

    this._loadingService.register('loading');
    this.saving = true;

    // Add the items to the PO
    this.currentPo.items = this.items;
    this._poService.createPo(this.currentPo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentPo.id = response['id']
          this.currentPo.po_number = response['po_number'];

          this.originalPo = Object.assign({}, this.currentPo);

          this.isEditMode = true;
          this._dialogService.openAlert({
            message: 'Purchase Order ' + this.currentPo.po_number + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            // If we do create it as ORDERED we need to create the receiving
            if (this.currentPo.status == 'ORDERED') {
              this._receivingService.createReceiving(this.currentPo.id + '').subscribe(
                response => {
                  this._dialogService.openAlert({
                    message: 'A receiving order has been created',
                    title: 'Info',
                  }).afterClosed().subscribe(
                    result => {
                      this.router.navigate(['/purchasing', 'po'])
                    }
                  );
                }
              );
            } else {
              this.router.navigate(['/purchasing', 'po']);
            }
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Purchase Order ' + this.currentPo.po_number + '.r',
            title: 'Failed!',
          });
        }
        this._loadingService.resolve('loading');
        this.saving = false;

      },
      error => {
        error = error.json()['error']['sqlMessage'];        
        console.log(error)
        this._dialogService.openAlert({
          message: 'Error creating Purchase Order: ' + error,
          title: 'Error!',
        });
        this._loadingService.resolve('loading');
        this.saving = false;

      },
      () => { }
    );
  }

  savePo() {
    // Avoid double-click issues
    if (this.saving) return;

    this._loadingService.register('loading');
    this.saving = true;

    // Add the items to the PO
    this.currentPo.items = this.items;
    console.log(this.currentPo)
    this._poService.updatePo(this.currentPo.po_id + '', this.currentPo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {

          this.originalPo = Object.assign({}, this.currentPo);

          this._dialogService.openAlert({
            message: 'Purchase Order ' + this.currentPo.po_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/purchasing', 'po']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Purchase Order ' + this.currentPo.po_number + '.',
            title: 'Failed!',
          });
        }
        this._loadingService.resolve('loading');
        this.saving = false;

        if (this.currentPo.status == 'ORDERED' && this.recv_pending) {
          this._receivingService.createReceiving(this.currentPo.po_id + '').subscribe(
            response => {
              this._dialogService.openAlert({
                message: 'A receiving order has been created',
                title: 'Info',
              });
            }
          );
        }
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Purchase Order ' + this.currentPo.po_number + ': ' + error,
          title: 'Error!',
        });
        this._loadingService.resolve('loading');
        this.saving = false;

      },
      () => { }
    );
  }

  removeItem(row: PoOrder) {
    this.items = this.items.filter(
      (line) => {
        return !(line.color_id == row.color_id && line.quantity == row.quantity && line.unit_price == row.unit_price)
      }
    );

    this.filter();
  }

  processEdit(po_number: string): Observable<Po> {
    this.title = 'edit';
    this.isEditMode = true;
    return this._poService.getOnePo(po_number);
  }

  processNew(): Observable<Po> {
    this.title = 'new';
    this.isEditMode = false;
    return Observable.of(new Po());
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.items;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    // Always alphabetical order on COLLECTION, then DESIGN, then COLOR
    newData = newData.sort(
      (a, b) => {
        /*
        return (a['collection_name'] != b['collection_name']) ?
          ((a['collection_name'] > b['collection_name']) ? 1 : -1) :
          ((a['design_name'] != b['design_name']) ?
            ((a['design_name'] > b['design_name']) ? 1 : -1) :
            ((a['color_name'] > b['color_name']) ? 1 : -1))
            */
        // ignore collection on sort, only design then color
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );
    //newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  isDraft() {
    // DRAFT, ORDERED, RECEIVED, CANCELLED all have gone through Draft
    return (this.currentPo != null && (this.currentPo.status == 'PACKING LIST' || this.currentPo.status == 'DRAFT' || this.currentPo.status == 'ORDERED' || this.currentPo.status == 'RECEIVED' || this.currentPo.status == 'CANCELLED'));
  }

  isOrdered() {
    // RECEIVED and ORDERED are both on or after ORDERED
    return (this.currentPo != null && (this.currentPo.status == 'PACKING LIST' || this.currentPo.status == 'ORDERED' || this.currentPo.status == 'RECEIVED'));
  }

  isPackingList() {
    return (this.currentPo != null && (this.currentPo.status == 'PACKING LIST' || this.currentPo.status == 'RECEIVED'));
  }

  isReceived() {
    return (this.currentPo != null && this.currentPo.status == 'RECEIVED');
  }

  isCancelled() {
    return (this.currentPo != null && this.currentPo.status == 'CANCELLED');
  }

  goBack(): void {
    this.location.back();
  }

  printPO() {
    this._branchService.getBranch(this.currentPo.requesting_branch_id).subscribe(
      (branch: Branch) => {
        this._supplierService.getSupplier(this.currentPo.supplier_id).subscribe(
          (supplier: Supplier) => {
            this._reportService.purchaseOrderReport(this.currentPo, this.items, branch, supplier, true);
          }
        )
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/pos/po-new/po-new.component.ts